import './nodecursor.js';
import gsap from 'gsap';

$(function(){

    if ( $(window).width() >= 992 )
    {
        function Magnets(areaSelector, itemSelector){

            $(areaSelector).on('mousemove', function(e){
                // offset
                const offset = 0.3;
    
                // get item
                const area = $(this);
                const item = area.find(itemSelector);
    
                // get cursor position
                const areaOffset = area.offset(); 
                const relX = e.pageX - areaOffset.left;
                const relY = e.pageY - areaOffset.top;
    
                // get center and append offset
                const x = (relX - item.outerWidth() / 2) * offset;
                const y = (relY - item.outerHeight() / 2) * offset;
    
                // animate position
                gsap.to(item, { duration: 0.3, x: x, y: y, ease: "power3.out" });
            });
    
            $(areaSelector).on('mouseleave', function(e){
                // get item
                const item = $(this).find(itemSelector);
    
                // reset position
                gsap.to(item, { duration: .7, x: 0, y: 0, ease: "elastic.out" })
            });
        }
    
        Magnets('.magnet-area', '.magnet-item');
        
    
        // init node cursor
        NodeCursor({
            cursor : true, 
            node : true, 
            cursor_velocity : 0.3, 
            node_velocity : 0.15, 
            native_cursor : 'none', 
            element_to_hover : '.cursor-hover, a, button, input, textarea, select, label', 
            cursor_class_hover : 'expand',  
            hide_mode : true, 
            hide_timing : 2000, 
        });
    }

});